<div [formGroup]="form" class='form'>
  <mat-form-field class="form-field">
    @if (hasIcon()) {
      <mat-icon matPrefix [matTooltip]="getToolTipText()">{{iconName}}</mat-icon>
    }
    <input [disabled]='true' matInput readonly type="text" [placeholder]="placeHolder" [value]='vmp?.displayValue || vmp?.value' >
    <button type="button" matSuffix mat-icon-button
      [disabled]='disabled || vmp?.loading || false'
      (click)="actionClicked.emit(vmp)">
      <mat-icon >manage_search</mat-icon>
    </button>
  </mat-form-field>
  @if (vmp?.loading) {
    <mat-progress-bar class='loadingbar' mode='indeterminate'></mat-progress-bar>
  }
</div>
